import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled, { keyframes } from "styled-components";

interface IToolTipContainerProps {
    isIncognitoCart?: boolean;
}

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ToolTipContainer = styled.div<IToolTipContainerProps>`
    position: absolute;
    right: 0;
    left: 0;
    padding: 0 ${({ theme }) => theme.spacing.medium};
    z-index: 10;
    top: ${({ isIncognitoCart }) => (isIncognitoCart ? "84px" : "60px")};
    opacity: 0;
    animation: ${fadeIn} 150ms ease-out forwards;
    animation-delay: 1s;

    @supports (top: var(--sat)) {
        top: calc(var(--sat, 0px) + ${({ isIncognitoCart }) => (isIncognitoCart ? "84px" : "60px")});
    }
`;

export const ToolTipContentContainer = styled.div(({ theme }) => ({
    position: "relative",
    backgroundColor: theme.colors[theme.colorMode].text_Highest_Emphasis,
    padding: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.small}`,
    borderRadius: theme.spacing.medium,
    boxShadow: theme.elevation[theme.colorMode].button.boxShadow,
}));

export const IncognitoSilentTextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.xxSmall,
    alignItems: "center",
}));

export const SilentTextWrapper = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].rain,
    borderRadius: theme.spacing.xxLarge,
}));

export const SilentText = styled(Text)(() => ({
    fontSize: "10px",
    lineHeight: "18px",
    fontWeight: 800,
    padding: "0 6px",
    letterSpacing: "-0.2px",
}));

export const HideOrderTextWrapper = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));

export const HideOrderText = styled(Text)(() => ({
    fontWeight: 500,
}));

export const CloseIconWrapper = styled.div(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.small,
    right: theme.spacing.small,
}));

export const ToolTipPointer = styled.div(({ theme }) => ({
    position: "absolute",
    top: `-10px`,
    right: "50px",
    width: 0,
    height: 0,
    borderLeft: `10px solid transparent`,
    borderRight: `10px solid transparent`,
    borderBottom: `${theme.spacing.small} solid ${theme.colors[theme.colorMode].text_Highest_Emphasis}`,
}));
